<div mat-dialog-title></div>
<button class="close text-primary"(click)="closeDialog()">X</button>
<div>
<iframe [src]="videoLink" width="500" height="300" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
<div>